/**
 * 阿拉伯语（ar）
 */

import arLocale from 'element-ui/lib/locale/lang/ar'

export default {
  ...arLocale,
  common: {},
  // 语言
  lang: {
    english: 'إنجليزي',
    spanish: 'إسبانية',
    japanese: 'اليابانية',
    portuguese: 'البرتغالية',
    french: 'الفرنسية .',
    russian: 'روسي',
    arabic: 'اللغة العربية',
    german: 'ألماني',
    italian: 'الايطاليين',
    vietnam: 'فييت نام',
    turkey: 'تركيا .',
    korean: 'الكوريين',
    thai: 'التايلاندية',
    dutch: 'الهولندية',
    hebrew: 'العبرية',
    indonesian: 'اللغة الأندونيسية'
  },

  // 苏子龙
  // 现货页面 inSrock
  inSrock: {}

  // 张丰

  // 孙泽严
}
